import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
// @mui
import { styled, useTheme } from "@mui/material/styles";
import { Box, Stack, Drawer } from "@mui/material";
// hooks
import useResponsive from "../../../hooks/useResponsive";
import useCollapseDrawer from "../../../hooks/useCollapseDrawer";
// utils
import cssStyles from "../../../utils/cssStyles";
// config
import { NAVBAR } from "../../../config";
// components
import Scrollbar from "../../../components/Scrollbar";
import { NavSectionVertical } from "../../../components/nav-section";
//
import navConfig from "./NavConfig";
import NavbarAccount from "./NavbarAccount";
import CollapseButton from "./CollapseButton";
import useDetails from "../../../hooks/useDetails";
import { useState, useEffect } from "react";
import { navBarItems } from "../../../routes";
import { filteredNavConfig } from "./FilterNavItems";
// import useDetails from "src/hooks/useDetails";
import axios from "axios";
import TermsAndCondition from "../../../pages/Login/TermsAndCondition";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { de } from "date-fns/locale";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
    transition: theme.transitions.create("width", {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

// ----------------------------------------------------------------------

NavbarVertical.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function NavbarVertical({ isOpenSidebar, onCloseSidebar }) {
  const theme = useTheme();

  const { pathname } = useLocation();

  const isDesktop = useResponsive("up", "lg");
  const userDetails = useDetails();
  let uu_id = userDetails?.user_id;
  let u_role = userDetails?.rolesname[0];

  useEffect(() => {
    axios
      .post(`${process.env.REACT_APP_KAIZEN_API}/api/dev1/2222/firstlogin`, {
        id: uu_id,
      })
      .then((res) => {
        console.log(res);
        if (res.data.response == "success") {
          setOpenDialog(false);
          setTermsAccepted(true);
        } else {
          setOpenDialog(true);
        }
      });
  }, [uu_id]);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  const handleAccept = () => {
    // Handle logic when the user accepts the terms
    setTermsAccepted(true);
  };
  const handleCloseDialog = () => {
    axios
      .post(
        `${process.env.REACT_APP_KAIZEN_API}/api/dev1/2222/updatefirstlogin`,
        {
          id: uu_id,
          u_role: u_role,
        }
      )
      .then((res) => {
        setOpenDialog(false);
      });
  };

  // const handleClick = (id)=>{
  //   navigate("/dashboard/insurance",{state:{id}});
  // };

  const handleCloseeDialog = () => {
    setOpenDialog(true);
  };

  const {
    isCollapse,
    collapseClick,
    collapseHover,
    onToggleCollapse,
    onHoverEnter,
    onHoverLeave,
  } = useCollapseDrawer();

  // added filtered Nav items
  const details = useDetails();
  const [filteredNavItems, setFilteredNavItems] = useState([]);
  useEffect(() => {
    // details?.permission.push("tbi");
    // details?.permission.push("headache-cdss");
    const navItems = navBarItems(details?.permission).map(
      (item) => `/dashboard/${item}`
    );
    setFilteredNavItems(filteredNavConfig(navItems, navConfig));
  }, []);

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          // mt:3,
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          ...(isCollapse && { alignItems: "center" }),
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {isDesktop && !isCollapse && (
            <CollapseButton
              onToggleCollapse={onToggleCollapse}
              collapseClick={collapseClick}
            />
          )}
        </Stack>

        <NavbarAccount isCollapse={isCollapse} />
      </Stack>

      <NavSectionVertical
        navConfig={filteredNavItems}
        isCollapse={isCollapse}
      />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <>
      <Dialog open={openDialog} onClose={handleCloseeDialog}>
        <DialogTitle>Terms and Conditions</DialogTitle>
        <DialogContent>
          <TermsAndCondition />
          <FormControlLabel
            control={
              <Checkbox
                checked={termsAccepted}
                onChange={() => setTermsAccepted(!termsAccepted)}
              />
            }
            label="I have read and accept the terms and conditions"
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={handleCloseDialog}
            disabled={!termsAccepted}
          >
            Accept
          </Button>
          <Button color="primary" onClick={handleCloseeDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <RootStyle
        sx={{
          width: {
            lg: isCollapse
              ? NAVBAR.DASHBOARD_COLLAPSE_WIDTH
              : NAVBAR.DASHBOARD_WIDTH,
          },
          ...(collapseClick && {
            position: "absolute",
          }),
        }}
      >
        {!isDesktop && (
          <Drawer
            open={isOpenSidebar}
            onClose={onCloseSidebar}
            PaperProps={{ sx: { width: NAVBAR.DASHBOARD_WIDTH } }}
          >
            {renderContent}
          </Drawer>
        )}

        {isDesktop && (
          <Drawer
            open
            variant="persistent"
            onMouseEnter={onHoverEnter}
            onMouseLeave={onHoverLeave}
            PaperProps={{
              sx: {
                width: NAVBAR.DASHBOARD_WIDTH,
                borderRightStyle: "dashed",
                bgcolor: "background.default",
                transition: (theme) =>
                  theme.transitions.create("width", {
                    duration: theme.transitions.duration.standard,
                  }),
                ...(isCollapse && {
                  width: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
                }),
                ...(collapseHover && {
                  ...cssStyles(theme).bgBlur(),
                  boxShadow: (theme) => theme.customShadows.z24,
                }),
              },
            }}
          >
            {renderContent}
          </Drawer>
        )}
      </RootStyle>
    </>
  );
}
